import { useEffect, useState } from 'react';
import { EditZohoSalesIQAutoSetupSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZohoSalesIQIntegrationSettings/EditZohoSalesIQAutoSetupSettings/EditZohoSalesIQAutoSetupSettings';
import { useForm } from 'react-hook-form';
import { useGetZohoSalesIQSetupMutation } from 'src/services';
import { useParams } from 'react-router-dom';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

export const IntegrationFormZohoSalesIqChat = ({
  integration,
  close = undefined,
}: {
  integration?: SelectedIntegration;
  // Used as the form's submit handler, so it is called with the (empty) form values.
  close?: () => void;
}) => {
  const { id } = useParams();
  const { handleSubmit } = useForm();
  const [code, setCode] = useState('');
  const [getZohoSalesIQSetup, { data: setupResponse, isLoading: isLoadingZohoSalesIQSetup }] =
    useGetZohoSalesIQSetupMutation();

  useEffect(() => {
    if (id && integration.id) {
      getZohoSalesIQSetup({
        projectId: id,
        integrationId: integration.id,
      });
    }
  }, [id, integration]);

  useEffect(() => {
    if (setupResponse?.plug_code) {
      setCode(setupResponse.plug_code);
    }
  }, [setupResponse]);

  useLoaderWhile(isLoadingZohoSalesIQSetup);

  return (
    <form id={'integration-form'} onSubmit={handleSubmit(close)} className={'w-full overflow-auto'}>
      <EditZohoSalesIQAutoSetupSettings code={code} />
    </form>
  );
};
